export { default } from "@/features/profile/screens/followers-list";
